/**
 * 404 Not Found page component.
 */

import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useT } from '@/i18n';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useT();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Result
        status="404"
        title="404"
        subTitle={t('抱歉，您访问的页面不存在')}
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            {t('返回首页')}
          </Button>
        }
      />
    </div>
  );
};

export default NotFound;
